import React, { useState, useEffect, useCallback } from "react";
import { updateNotification } from "../api/notification/notification-api";
import { downloadNotifications, getNotificationCount } from "../api/user/notification-api";
import { doc, onSnapshot } from '@firebase/firestore';
import { db } from "../firebase";

let  notificationInterval;

export const notificationHandle = 
(
    setNotificationCount, 
    userId, 
    setErrorContent, 
    setIsSystemError, 
    notificationArray, 
    setNotificationArray, 
    refreshRequest, 
    refreshOrders,
    refreshPeopleRequest, 
    notificationIncrementSize, 
    notificationLowerLimit, 
    setIsLoadingNotifications, 
    setIsShowMoreNotification, 
    setNotificationLowerLimit, 
    notificationCount, 
    notificationPermission, 
    setNotificationPermission)  => 
    
    {        
        const fetchNotificationCount = async () => {
            try {
                setNotificationCount((await getNotificationCount(userId)).notificationCount);
            } catch (error) {
                console.log(error);
                //setErrorContent({ 'header': "Error getting Notification Count", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                //setIsSystemError(true);
            }
        };

        const notificationSeen = useCallback(async (notificationId, fromUserId) => {
            let seenCount = 0;
            let newArray = [...notificationArray];
            for (let x in newArray) {
                if (newArray[x].notificationId === notificationId && newArray[x].fromUserId === fromUserId) {
                    if (newArray[x].notificationStatus === "unseen") {
                        newArray[x].notificationStatus = "seen";
                        seenCount++;
                    }
                }
            }
            setNotificationArray(newArray);
            setNotificationCount(notificationCount => notificationCount - seenCount);

            try {
                await updateNotification(userId, notificationId);
                refreshRequest()
                refreshOrders()
                refreshPeopleRequest();
                refreshNotification();
            } catch (error) {
                console.log(error);
                setErrorContent({ 'header': "Error updating Notifications", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                setIsSystemError(true);
            }
        },[userId])

        const getNotifications = useCallback(async () => {   
            if(!userId) return         
            try {
                let response = await downloadNotifications(userId, notificationIncrementSize, notificationLowerLimit);
                setIsLoadingNotifications(false);
                if (notificationLowerLimit === 0) {
                    setNotificationArray(response);
                    if (response.length < notificationIncrementSize) {
                        setIsShowMoreNotification(false);
                    }
                } else {
                    let newItemCount = response.length;
                    setNotificationArray(notificationArray => [...notificationArray, ...response]);
                    if (newItemCount < notificationIncrementSize) {
                        setIsShowMoreNotification(false);
                    }
                }
            } catch (error) {
                console.log(error);
                setErrorContent({ 'header': "Error getting Notification Count", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
                setIsSystemError(true);
                setIsLoadingNotifications(false);
            }
        }, [userId, notificationIncrementSize, notificationLowerLimit])

        const refreshNotification = useCallback(() => {
            if(!userId) return
            return new Promise((resolve, reject) => {
                setIsLoadingNotifications(true)
                setIsShowMoreNotification(true);
                fetchNotificationCount();
                if(notificationLowerLimit === 0){
                    getNotifications()
                } else {
                    //If the lower limit is not 0, then setting it to 0 will automatically trigger the useEffect for refresh
                    setNotificationLowerLimit(0)                
                } 
                resolve("success");
            });
        },[userId])

        //onrefresh(when notificationLowerLimit set to triggers useEffect) and on first time load
        useEffect(() => {
            if (!userId)
                return;
            if(notificationLowerLimit > 0) return
                getNotifications()
        }, [userId, notificationLowerLimit])

        const getNoticationPermission = useCallback(async() => {
            let permission = await Notification.requestPermission();
            setNotificationPermission(permission)
        }, [])

        const showNotification = useCallback((notificationType) => {
            // create a new notification   
            if(typeof Notification === "undefined") return  

            let body = "New Request"
            let redirectUri = "https://www.stringssg.com/home"
            
            if(notificationType === "chat"){
                body = "New Message"
                redirectUri = "https://www.stringssg.com/notification"
            }
            // console.log(Notification)   
            const notification = new Notification('StringsSG Notification', {
                body: body,
                icon: 'https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png',
                silent: true
            });
            
            const beat = new Audio('/assets/whatsapp-notification-ding.mp3');
            beat.play();
    
            // close the notification after 10 seconds
            setTimeout(() => {
                notification.close();
            }, 20 * 1000);
        
            // navigate to a URL
            notification.addEventListener('click', () => {
                window.open(redirectUri, '_blank');
            });
        }, [])

        //on first time load get the notification counts and get the counts every 5 secs.     
        useEffect(() => {
            if (!userId) return   

            fetchNotificationCount();
            const unsubscribe = onSnapshot(doc(db, "appNotification", userId), (doc) => {
                fetchNotificationCount()

                let notification = doc.data()
                // console.log(notification)
                if(notification?.type === "chat" || notification?.type === "newRequest"){
                    const date = new Date(notification?.lastMessageTime.seconds * 1000)
                    const currentDate = new Date()
                    // console.log((currentDate.getTime() - date.getTime())/1000)
                    if((currentDate.getTime() - date.getTime())/1000 < 180){
                        showNotification(notification?.type)
                    }
                }
            });   

            return () => unsubscribe();

        }, [userId]);

        useEffect(() => {
            if (!userId) return
            if(notificationPermission === "granted") return
            
            getNoticationPermission()

        }, [userId, notificationPermission, getNoticationPermission])

        return { refreshNotification, notificationSeen, getNotifications };
}